<script>
import Table from './components/Comite/Greater10/ComiteTable'

/**
 * Basic Tables component
 */
export default {
  components: {
    Table,
  },
  data() {
    return {
      title: "Listado de actas",
      acts: [],

    };
  },
};
</script>

<template>

  <div class="row">
    <div class="col-lg-12">
      <div>
        <div class="card-body">

          <Table />

        </div>
      </div>
      <!-- end card -->
    </div>

  </div>
  <!--- end row -->


</template>